module.exports = __webpack_public_path__ + "img/soundwave-gif.a629b7ea.gif";